import {RootDesc} from "@ui/descriptions/RootDesc";
import {SmallDesc} from "@ui/descriptions/SmallDesc";
import {RadioGroup} from "@ui/inputs/RootRadio";

import styles from "../styles.module.scss";

export const ScenarioCriteriaList = ({criteriaOptions = []}) => {
  if (!criteriaOptions.length) {
    return null;
  }

  return (
    <ul className={styles.criteriaContent}>
      {criteriaOptions.map((item) => (
        <li key={item.sectionId}>
          <RootDesc>
            <b dangerouslySetInnerHTML={{__html: item.label}} />
          </RootDesc>

          <ul>
            {item.criteria.map((criterion) => (
              <li key={criterion.criterionId}>
                <SmallDesc>
                  <span
                    dangerouslySetInnerHTML={{__html: criterion.label}}
                  />
                </SmallDesc>

                <RadioGroup
                  rating
                  ratingType={"bullet"}
                  required={false}
                  name={`scenario-criterion-weight-${criterion.criterionId}`}
                  value={criterion.weight}
                  disabled
                />
              </li>
            ))}
          </ul>
        </li>
      ))}
    </ul>
  );
};
